/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/info
 */
import { default as DefaultIcon } from '~icons/lucide/info';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const InfoIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
